import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import {ModalModificaCategoria} from './ModalModificaCategoria';
import {ModalDeleteCategoria} from './ModalDeleteCategoria';

export const CardCategoria = (props) => {
	const {
		categoria,
		id,
		superCategoria,
		definirCategoriasServicios,
		ListaSuperCategorias,
		ListaNombreSuperCategorias,
	} = props;
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	const [UseModalDeleteCategoria, setUseModalDeleteCategoria] = useState(false);
	const [nombreModifyCategoria, SetNombreModifyCategoria] = useState({
		nombre: categoria,
		superCategoria: superCategoria,
	});
	const [UseModalModifyCategoria, setUseModalModifyCategoria] = useState(false);

	const [NombreSuperCategoria, setNombreSuperCategoria] = useState('-------');

	const modifyCategoria = () => {
		axios({
			method: 'put',
			url: window.ipdirection + 'categoria/' + id + '/',
			data: {
				nombre: nombreModifyCategoria.nombre,
				superCategoria: nombreModifyCategoria.superCategoria,
			},
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			definirCategoriasServicios();
			SetNombreModifyCategoria(nombreModifyCategoria);
			getNombreSuperCategoria(nombreModifyCategoria.superCategoria);
			setUseModalModifyCategoria(false);
		});
	};

	const deleteCategoria = () => {
		console.log(id);
		axios({
			method: 'delete',
			url: window.ipdirection + 'categoria/' + id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			definirCategoriasServicios();
			setUseModalDeleteCategoria(false);
		});
	};
	const getNombreSuperCategoria = (id) => {
		let nombre = '';
		ListaSuperCategorias.map((superCat) => {
			if (superCat.id === id) {
				nombre = superCat.nombre;
			}
		});
		setNombreSuperCategoria(nombre);
	};

	useEffect(() => {
		getNombreSuperCategoria(superCategoria);
	}, []);

	return (
		<>
			<div className='tipoServicio'>
				<div className='derTipoServicio'>
					<div className='centradorLeft'>
						<b>Categoria</b>
						<p className='descripcionCardCategoriaServicio'>{categoria}</p>
					</div>
					<div className='centradorLeft'>
						<b>Super categoria</b>
						<p className='descripcionCardCategoriaServicio'>{NombreSuperCategoria}</p>
					</div>
				</div>
				<div className='tipoCategoriaOptions'>
					<div
						className='tipoCategoriaOptionModify'
						onClick={() => setUseModalModifyCategoria(true)}
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='20'
							height='20'
							fill='currentColor'
							className='bi bi-pencil-square'
							viewBox='0 0 16 16'
						>
							<path d='M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z' />
							<path
								fillRule='evenodd'
								d='M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z'
							/>
						</svg>
					</div>
					<div
						className='tipoCategoriaOptionDelete'
						onClick={() => setUseModalDeleteCategoria(true)}
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='20'
							height='20'
							fill='currentColor'
							className='bi bi-trash'
							viewBox='0 0 16 16'
						>
							<path d='M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z' />
							<path
								fillRule='evenodd'
								d='M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z'
							/>
						</svg>
					</div>
				</div>
			</div>
			<ModalModificaCategoria
				UseModalModifyCategoria={UseModalModifyCategoria}
				setUseModalModifyCategoria={setUseModalModifyCategoria}
				SetNombreModifyCategoria={SetNombreModifyCategoria}
				nombreModifyCategoria={nombreModifyCategoria}
				modifyCategoria={modifyCategoria}
				ListaSuperCategorias={ListaSuperCategorias}
				ListaNombreSuperCategorias={ListaNombreSuperCategorias}
			/>
			<ModalDeleteCategoria
				UseModalDeleteCategoria={UseModalDeleteCategoria}
				setUseModalDeleteCategoria={setUseModalDeleteCategoria}
				deleteCategoria={deleteCategoria}
			/>
		</>
	);
};
